export const OKTELL_WAITLIST_STATUSES_WITH_DATE = [213, 234]
export const OKTELL_WAITLIST_INPUTS_WITH_DATE = [
    336, 337, 338, 301, 319, 303, 310, 304, 316, 345, 334, 307,
]
